import { render, staticRenderFns } from "./403.vue?vue&type=template&id=e1fa96e6&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fa96e6",
  null
  
)

export default component.exports